/** Every plan a product can put a company on. A company is on the highest plan among the products it holds. */
export const PRODUCT_PLANS = ['Pro', 'Plus', 'Autopilot'];

/** The plans an add-on can need: every company is at least on Pro, so needing Pro would mean needing nothing. */
export const ADD_ON_PLANS = ['Plus', 'Autopilot'];

/** The chip beside a product in the Pricings tab, or null for a product that is neither a plan nor an add-on. */
export function productPlanLabel(productPlan) {
  if (productPlan !== null && productPlan !== void 0 && productPlan.plan) return "Plan: ".concat(productPlan.plan);
  if (productPlan !== null && productPlan !== void 0 && productPlan.addOnNeedsPlan) return "Add-on: needs ".concat(productPlan.addOnNeedsPlan);
  return null;
}

/**
 * The confirmation before a plan change that moves companies, or null when it moves none. Only the plan is compared: an
 * add-on need moves nobody's tier.
 */
export function planChangeWarning(productName, productPlan, nextPlan) {
  var _productPlan$activeCo, _productPlan$plan, _productPlan$plan2;
  const companies = (_productPlan$activeCo = productPlan === null || productPlan === void 0 ? void 0 : productPlan.activeCompanies) !== null && _productPlan$activeCo !== void 0 ? _productPlan$activeCo : 0;
  if (companies === 0 || ((_productPlan$plan = productPlan === null || productPlan === void 0 ? void 0 : productPlan.plan) !== null && _productPlan$plan !== void 0 ? _productPlan$plan : '') === nextPlan) return null;
  const holders = companies === 1 ? '1 company holds' : "".concat(companies, " companies hold");
  const from = (_productPlan$plan2 = productPlan === null || productPlan === void 0 ? void 0 : productPlan.plan) !== null && _productPlan$plan2 !== void 0 ? _productPlan$plan2 : 'no plan';
  const to = nextPlan || 'no plan';
  return "".concat(holders, " ").concat(productName || 'this product', " on an active subscription. ") + "A company's plan is read from the products it holds, so changing this one from ".concat(from, " to ").concat(to, " ") + 'can change theirs as soon as you save.';
}